import Image from "next/image";
import { useEffect, useState } from "react"

export const FallBackImage = ({ src, width = 430, height = 270, fill = true, ...rest }) => {
    const [imgSrc, setImgSrc] = useState(src);
    useEffect(() => { setImgSrc(src); }, [src]);

    return (
        <Image
            {...rest}
            src={imgSrc ? imgSrc : '/img/no-image.jpeg'}
            width={fill ? undefined : width}
            height={fill ? undefined : height}
            fill={fill}
            style={{ objectFit: 'cover', ...rest.style }}
            onError={() => { setImgSrc('/img/no-image.jpeg') }} />
    )
}